module.exports = __webpack_public_path__ + "static/GlaubAnDich2019Finalist-4fcdfc690d25bf437449bb69d84e3d8a.png";